import React from 'react';
import PropTypes from 'prop-types';
import {
  Body,
  Box,
} from '../../coreui';

const Blurb = ({
  blurb,
}) => {
  return (
    <Box
      w={1}
      py={[20, 40]}
      px={[40, 40]}
    >
      <Body
        type="B1"
        align="center"
        display="block"
        m={0}
        w={1}
        color="gray.8"
      >
        { blurb }
      </Body>
    </Box>
  );
};

Blurb.propTypes = {
  blurb: PropTypes.string,
};

export default Blurb;
